import * as Sentry from "@sentry/react-native";
import Constants from "expo-constants";
import { nativeBuildVersion } from "expo-application";
import { Platform } from "react-native";
const dist =
    Platform.OS === "web"
        ? `${Constants.expoConfig.extra.bundleIdentifier}@${
              require("../../build_numbers.json").storeVersion
          }+web`
        : nativeBuildVersion;

if (Constants.expoConfig.extra.sentryDSN) {
    Sentry.init({
        dsn: Constants.expoConfig.extra.sentryDSN,
        environment: Constants.expoConfig.extra.appEnv,
        dist: dist,
        debug: Constants.expoConfig.extra.appEnv !== "production",
        // See https://docs.expo.dev/guides/using-sentry/#troubleshooting at "expo-dev-client transactions never finish"
        tracesSampleRate: 1.0,
    });
}
